"use client";

import { styled } from "@mui/material/styles";
import Box, { BoxProps } from "@mui/material/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";
import Typography from "@mui/material/Typography";
import { useFormFunnelHeadingLevel } from "./FormFunnelHeadingContext";

interface LoadingScreenProps extends BoxProps {
  /** Override the default headline. ENG-6248 uses this to vary copy between
   * the initial "Finding your match…" and post-contact "Verifying your
   * match…" loading screens. */
  message?: string;
}

export const LoadingScreen = ({ message, ...props }: LoadingScreenProps) => {
  const headingLevel = useFormFunnelHeadingLevel();
  return (
    <Container {...props}>
      <Content>
        <Spinner icon={faSpinner} spin />
        <Typography variant="h4" component={headingLevel} sx={{ mt: 2, fontWeight: 600 }}>
          {message ?? "Matching you to a program..."}
        </Typography>
      </Content>
    </Container>
  );
};

const Container = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: ${({ theme }) => theme.palette.background.default};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 2rem;
`;

const Spinner = styled(FontAwesomeIcon)`
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;
